"use client";

import { useSectionReveal } from "./useSectionReveal";

export default function CTASection() {
  const sectionRef = useSectionReveal<HTMLElement>();

  return (
    <section className="iv-section iv-cta-section" ref={sectionRef}>
      <div className="iv-section__inner" style={{ textAlign: "center" }}>
        <h2 className="iv-cta-section__title iv-font-display">
          Ready to Create Your Invitation?
        </h2>
        <p className="iv-cta-section__sub">
          Join hundreds of couples who made their wedding unforgettable with a
          beautiful digital invitation.
        </p>
        <a
          href="https://wa.me/919553143929?text=Hi%2C%20I%27d%20like%20to%20create%20a%20wedding%20invitation"
          className="iv-btn iv-btn--gold"
          target="_blank"
          rel="noopener noreferrer"
        >
          Start Your Invitation
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 8h10M9 4l4 4-4 4" />
          </svg>
        </a>
      </div>
    </section>
  );
}
